import { render, staticRenderFns } from "./ViewPartsRequirement.vue?vue&type=template&id=53931d3a&"
import script from "./ViewPartsRequirement.vue?vue&type=script&lang=js&"
export * from "./ViewPartsRequirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports